<template lang="pug">
video.movie-base
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

/**
 * videoタグ
 */
@Component
export default class VideoBase extends Vue {}
</script>
